module.exports = __webpack_public_path__ + "themes/fq/img/spin-sign@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/spin-sign@2x.png
// module id = 65
// module chunks = d-game